// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-tracker {
  width: 100%;
  position: relative;
  left: 0;
  border: none;
  height: 0.5rem;
  margin: 1rem 0;
  -webkit-appearance: none;
  appearance: none;
}

progress::-webkit-progress-value {
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
}


/*Volvia Design System CSS:*/

.progress-tracker {
  background-color: #F6F8F9;
}
progress::-webkit-progress-bar {
  background-color: #F6F8F9;
}

progress::-webkit-progress-value {
  background-color: #789ba2;
}

/*Firefox styling:*/
progress::-moz-progress-bar {
  background: #F6F8F9;
  background-color: #789ba2;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ProgressTracker/ProgressTracker.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,cAAc;EACd,cAAc;EACd,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;;AAGA,4BAA4B;;AAE5B;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC","sourcesContent":[".progress-tracker {\r\n  width: 100%;\r\n  position: relative;\r\n  left: 0;\r\n  border: none;\r\n  height: 0.5rem;\r\n  margin: 1rem 0;\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n}\r\n\r\nprogress::-webkit-progress-value {\r\n  border-top-right-radius: 7px;\r\n  border-bottom-right-radius: 7px;\r\n}\r\n\r\n\r\n/*Volvia Design System CSS:*/\r\n\r\n.progress-tracker {\r\n  background-color: #F6F8F9;\r\n}\r\nprogress::-webkit-progress-bar {\r\n  background-color: #F6F8F9;\r\n}\r\n\r\nprogress::-webkit-progress-value {\r\n  background-color: #789ba2;\r\n}\r\n\r\n/*Firefox styling:*/\r\nprogress::-moz-progress-bar {\r\n  background: #F6F8F9;\r\n  background-color: #789ba2;\r\n  border-top-right-radius: 7px;\r\n  border-bottom-right-radius: 7px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
